import { Link, useRouterState } from "@tanstack/react-router";
import { cn } from "@theprelude/core";
import { IconButton, InfoIcon } from "@theprelude/ds";
import { DefaultTooltip } from "./default-tooltip";

export const SelectThreatIcon: React.FC<{
  id: string;
  children?: React.ReactNode;
  className?: string;
}> = ({ id, children, className }) => {
  const router = useRouterState();
  return (
    <Link
      className={cn("group flex min-w-0 items-center gap-1", className)}
      to={router.location.pathname}
      search={(prev) => {
        return { ...prev, overlay: ["threat", { id }] };
      }}
      params={(prev) => prev}
    >
      {children}
      <DefaultTooltip asChild content="Open threat">
        <IconButton
          className="inline-flex group-hover:text-primary-foreground"
          icon={<InfoIcon />}
        />
      </DefaultTooltip>
    </Link>
  );
};

export const SelectEndpointIcon: React.FC<{
  id: string;
  children?: React.ReactNode;
  className?: string;
}> = ({ id, children, className }) => {
  const router = useRouterState();
  return (
    <Link
      className={cn("group flex min-w-0 items-center gap-1", className)}
      to={router.location.pathname}
      search={(prev) => {
        return { ...prev, overlay: ["endpoint", { id }] };
      }}
      params={(prev) => prev}
    >
      {children}
      <DefaultTooltip asChild content="Open endpoint">
        <IconButton
          className="inline-flex group-hover:text-primary-foreground"
          icon={<InfoIcon />}
        />
      </DefaultTooltip>
    </Link>
  );
};

export const SelectTestIcon: React.FC<{
  id: string;
  children?: React.ReactNode;
  className?: string;
}> = ({ id, children, className }) => {
  const router = useRouterState();
  return (
    <Link
      className={cn("group flex min-w-0 items-center gap-1", className)}
      to={router.location.pathname}
      search={(prev) => {
        return { ...prev, overlay: ["test", { id }] };
      }}
      params={(prev) => prev}
    >
      {children}
      <DefaultTooltip asChild content="Open test">
        <IconButton
          className="inline-flex group-hover:text-primary-foreground"
          icon={<InfoIcon />}
        />
      </DefaultTooltip>
    </Link>
  );
};

export const SelectTechniqueIcon: React.FC<{
  id: string;
  children?: React.ReactNode;
  className?: string;
}> = ({ id, children, className }) => {
  return (
    <Link
      className={cn("group flex min-w-0 items-center gap-1", className)}
      to="/dashboard/tests"
      search={(prev) => {
        return { ...prev, search: id };
      }}
      params={(prev) => prev}
    >
      {children}
      <DefaultTooltip asChild content="Open technique">
        <IconButton
          className="inline-flex group-hover:text-primary-foreground"
          icon={<InfoIcon />}
        />
      </DefaultTooltip>
    </Link>
  );
};
